export default {
  init() {
    // Filter products when selecting a hotspot
    $(".hotspot").click(function () {
      let category = $(this).data("category");
      $(".products .product").each(function () {
        $(this).hide();
        let product = $(this).data("product");
        if (product == category) {
          $(this).show();
        }
      });
    });

    function setHeaderImage(header) {
      if (typeof $(".anatomy-headers").data("header") !== "undefined") {
        $(".anatomy-headers").each(function () {
          if ($(this).data("header") === header) {
            $(this).css({ display: "flex" });
          } else {
            $(this).hide();
          }
        });

        $(".anatomy-content").each(function () {
          if ($(this).data("content") === header) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
    }

    // Show all products
    $("#all-products").click(function (e) {
      e.preventDefault();
      setHeaderImage("all");
      $("#products .product").each(function () {
        $(this).fadeIn();
      });
      $("#videos .video").each(function () {
        $(this).fadeIn();
      });
    });

    // Change filter text depending on screen size
    $(window).on("load resize", function () {
      const showText = $("#hide-filters").data("show-text");
      $("#hide-filters").text(showText);
    });

    function showReleventProducts(self) {
      let filterBy = $.trim(self.text().replace(/,/g, ""));
      setHeaderImage(self.text().toLowerCase());
      $("#products .product").each(function () {
        let filter = $(this).data("filters");
        filter = filter.split(",");
        if (jQuery.inArray(filterBy, filter) !== -1) {
          $(this).show();
        } else {
          $(this).fadeOut();
        }
      });
    }

    function showReleventVideos(self) {
      const text = self.text().replace(/\s/g, "").toLowerCase();
      let filterBy = $.trim(text.replace(/,/g, ""));
      setHeaderImage(self.text().toLowerCase());
      $("#videos .video").each(function () {
        let filter = $(this).data("filters");
        filter = filter.split(",");
        if (jQuery.inArray(filterBy, filter) !== -1) {
          $(this).show();
        } else {
          $(this).fadeOut();
        }
      });
    }

    // Show/Hide filters
    $("#hide-filters").click(function (e) {
      e.preventDefault();
      const showText = $("#hide-filters").data("show-text");
      const hideText = $("#hide-filters").data("hide-text");
      if ($(this).text() == hideText) {
        $(this).text(showText);
        $("#filters").hide();
        $("#video-filters").hide();
        $("#products").attr("class", "col-lg-12");
        $("#videos").attr("class", "col-lg-12");
        $("#products .product").each(function () {
          $(this).fadeIn();
          $(this).removeClass("col-xl-4");
        });
        $("#videos .video").each(function () {
          $(this).fadeIn();
        });
      } else {
        $(this).text(hideText);
        $("#filters").show();
        $("#video-filters").show();
        $("#products").attr("class", "col-lg-12 col-xl-9");
        $("#products .product").addClass("col-xl-4");
        $("#videos").attr("class", "col-lg-12 col-xl-9");
      }
    });

    // Toggle filter menu iltems
    $(".product-filter li.title").click(function () {
      if ($(this).next(".items").length > 0) {
        $(this).next(".items").slideToggle();
        $(this).next(".items").removeClass("items-open");
        $(this).find("i").toggleClass("flip");
      } else {
        showReleventProducts($(this));
      }
    });

    $(".video-filter li.title").click(function () {
      if ($(this).next(".items").length > 0) {
        $(this).next(".items").slideToggle();
        $(this).next(".items").removeClass("items-open");
        $(this).find("i").toggleClass("flip");
      } else {
        showReleventVideos($(this));
      }
    });

    $(".product-filter .items a").click(function (e) {
      e.preventDefault();
      showReleventProducts($(this));
    });

    $(".video-filter .items a").click(function (e) {
      e.preventDefault();
      showReleventVideos($(this));
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/products.js